import { Model } from "@vuex-orm/core"
import EventData from "./EventData"

export default class Events extends Model {
  static entity = "events"

  static fields() {
    return {
      id: this.string(""),
      year: this.number(0),
      data: this.attr([])
    }
  }

  id!: string
  year!: number
  data!: EventData[]
}
